import React, {useEffect, useRef, createRef, useState } from 'react';

import AudioPlayer from '@user-pages/exercise/common/AudioPlayer'
import StartButton from '@user-pages/exercise/common/StartButton'
import CustomerRequestDialog from "@user-components/CustomerRequestDialog"

import {Grid, Box, Typography} from '@material-ui/core';
import SocketProvider from '@user-provider/SocketProvider';
import AuthProvider from '@user-provider/AuthProvider';
import MeasureHelper from '@helper/MeasureHelper'
// import ExerciseStatusBar from "./ExerciseStatusBar";

import StartMeasureDialog from "./StartMeasureDialog";
import EndMeasureDialog from "./EndMeasureDialog";
import PrescriptionService from '@user-service/PrescriptionService'

import queryString from "query-string";
import {useParams} from "react-router-dom";
import {RealtimeMeasureChart} from "./RealTimeMeasureChart";
const { measureTypeToCode } = MeasureHelper
const MeasureHzType = 'measureBandTest'

let MeasureCodes = ['MA','MM','MB'] 


function MeasureProgressPanel({ progressRef }) {
    const [progress, setProgress] = useState({ ...progressRef.current })

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress({ ...progressRef.current })
        }, 1000)
        return () => clearInterval(timer)
    }, [progressRef])

    if (61 !== AuthProvider.get('profileID')) return null

    return (
        <Box style={{
            position: 'fixed',
            bottom: 20,
            left: 20,
            zIndex: 99,
            backgroundColor: 'rgba(0,0,0,0.6)',
            borderRadius: 10,
            padding: '10px 16px',
        }}>
            {['MA', 'MM', 'MB'].map((code) => {
                const info = progress[code]
                const isPlaying = info.status === 'playing'
                const isCompleted = info.status === 'completed'
                const statusLabel = isCompleted ? '완료' : isPlaying ? '측정중' : '대기'
                const statusColor = isCompleted ? '#4CAF50' : isPlaying ? '#FFC004' : '#888'
                const min = Math.floor(info.time / 60)
                const sec = info.time % 60
                const timeText = `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
                return (
                    <Box key={code} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        marginBottom: code !== 'MB' ? 6 : 0,
                    }}>
                        <Typography style={{
                            color: isPlaying ? '#FFC004' : '#fff',
                            fontWeight: isPlaying ? 'bold' : 'normal',
                            fontSize: 16,
                            width: 30,
                        }}>{code}</Typography>
                        <Typography style={{
                            color: statusColor,
                            fontSize: 14,
                            width: 50,
                            textAlign: 'center',
                        }}>{statusLabel}</Typography>
                        <Typography style={{
                            color: '#fff',
                            fontSize: 14,
                            fontFamily: 'monospace',
                        }}>{timeText}</Typography>
                    </Box>
                )
            })}
        </Box>
    )
}

const MeasureBandTest = (props) => {
    const audioRef = useRef()
    const measureRef = useRef()
    const runningTime = 90

    const qs = queryString.parse(window.location.search)
    const [isRequest] = useState(undefined !== qs.rq)
    const [requestID] = useState(qs.rqs)
    const { prescriptionID } = useParams()
    
    const [currentMeasureCode, setMeasureCode] = useState(null)
    const [showStartDialog, setShowStartDialog] = useState(false)
    const [showEndDialog, setEndDialog] = useState(false)
    const measureProgressRef = useRef({
        MA: { status: 'ready', time: 0 },
        MM: { status: 'ready', time: 0 },
        MB: { status: 'ready', time: 0 },
    })
    const measureCodeRef = useRef(null)

    const fetch = async () => {
        SocketProvider.connect(async ()=> {
            if(!isRequest && !showStartDialog) {
                setShowStartDialog(true)
            }
        }, window, MeasureHzType)
    }
    
    useEffect(()=>{
        // SocketProvider.connect(()=>{}, window, MeasureHzType)
        MeasureCodes = ['MA','MM','MB']
        fetch().then()
        
        SocketProvider.onMeasure = (data) => {
            measureRef.current.update(data)
            const code = measureCodeRef.current
            if (code && measureProgressRef.current[code]) {
                measureProgressRef.current[code] = { status: 'playing', time: data.time }
            }
        }
        
        // 자동 재측정 콜백 등록 - 목표시간 미달 시 retry 상태 추적
        let isAutoRetrying = false
        let isProcessingStop = false
        SocketProvider.onAutoRetryMeasure = (remainingTime) => {
            console.log(`[MeasureBandTest] 자동 재측정 시작 - 남은시간: ${remainingTime}초`)
            isAutoRetrying = true
        }

        SocketProvider.onMeasureStop = async ({fileKey}) => {
            // 자동 재측정 중이면 코드 전환하지 않음
            if(isAutoRetrying) {
                console.log(`[MeasureBandTest] 재측정 중 stop 무시`)
                isAutoRetrying = false
                return
            }

            // 중복 stop 호출 방지
            if(isProcessingStop) {
                console.log(`[MeasureBandTest] 중복 stop 무시`)
                return
            }
            isProcessingStop = true

            // 현재 코드를 completed로 변경
            const code = measureCodeRef.current
            if (code && measureProgressRef.current[code]) {
                measureProgressRef.current[code] = { ...measureProgressRef.current[code], status: 'completed' }
            }

            const measureCode = MeasureCodes.shift()

            await measureRef.current.saveImage(fileKey)

            if(!measureCode) {
                measureRef.current.updateChart()
                if(SocketProvider.isBRHWService){
                    await PrescriptionService.updateStatus(prescriptionID, 'measureBandTest', measureTypeToCode(currentMeasureCode), 'C', 'measure-completed')
                    await PrescriptionService.getUpdateRequest(requestID)
                }

                setEndDialog(true)
                return
            }

            setMeasureCode(measureCode)
            measureCodeRef.current = measureCode
            setTimeout(() => {
                isProcessingStop = false
                setShowStartDialog(true)
                // startExercise(runningTime, 'type1', measureCode).then()
            },1000)

        }

        return () => {
            SocketProvider.onAutoRetryMeasure = null
            SocketProvider.measureStop(true).then()
        }
    },[])

    const startExercise = async (runningTime, measureType, measureCode) => {
        measureRef.current.clear()
        measureRef.current.updateChart()
        await SocketProvider.measureStart(runningTime, prescriptionID, MeasureHzType, measureType, measureTypeToCode(measureType), measureCode)
    }
    
    return (
        <Box style={{position: 'relative'}}>
            <Box
                display="flex"
                justifyContent="flex-end"
                position="absolute"
                right={10}
                top={10}
                zIndex={99}
            >
                <Grid container justify="center" spacing={1}>
                    <Grid item>
                        <StartButton
                            onStop={async () =>{
                              MeasureCodes = []
                                // await SocketProvider.measureStop(false, true)
                              document.location.href = `/measureSelect`
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            {isRequest &&
            <CustomerRequestDialog
                handleStart={() => {
                    // setShowStartDialog(true)
                }
                }/>
            }
            
            {/*<ExerciseStatusBar*/}
            {/*    measureHzType={MeasureHzType}*/}
            {/*    measureType={'type1'}*/}
            {/*    hideIntervalTime={true}*/}
            {/*    disableMeasureType={true}*/}
            {/*    close={async () => {*/}
            {/*        await stopExercise()*/}
            {/*    }}*/}
            {/*    start={async () => {*/}
            {/*        if(0 === MeasureCodes.length){*/}
            {/*            MeasureCodes = ['MA','MM','MB']*/}
            {/*        }*/}
            {/*        const measureCode = MeasureCodes.shift()*/}
            {/*        await startExercise(runningTime, 'type1', measureCode)*/}
            {/*    }}*/}
            {/*/>*/}
            <MeasureProgressPanel progressRef={measureProgressRef} />

            <Box className={'innerViewport'}>
                {/*<RealtimeMeasure ref={measureRef} prescriptionID={prescriptionID}/>*/}
                <RealtimeMeasureChart ref={measureRef} prescriptionID={prescriptionID} />
            </Box>
            
            <StartMeasureDialog
                onHide={async () => {
                    let measureCode = currentMeasureCode
                    if(!measureCode){
                        measureCode = MeasureCodes.shift()
                        setMeasureCode(measureCode)
                        measureCodeRef.current = measureCode
                    }
                    await startExercise(runningTime, 'type1', measureCode)
                    setShowStartDialog(false)
                }}
                measureCode={currentMeasureCode}
                open={showStartDialog}
                // open={false}
                history={props.history}
                />

            <EndMeasureDialog
                open={showEndDialog}
                history={props.history}
                prescriptionID={prescriptionID}
                />
            
            <AudioPlayer ref={ audioRef } />
        </Box>
    );
}

// 실시간 측정 페이지



export default MeasureBandTest
